import { type ReactNode } from 'react';
import { COLORS } from '../../constants/style/color';
import { type ModalStatusType } from '../../types/common';
// import CheckPermissions from '../../utils/checkPermission';
import Spinners from '../spinner';
import { Btn } from './button.styled';
import { useSelector } from 'react-redux';
import { selectAuthRoutesList } from '../../pages/configuration/routeSlice';

interface ButtonType {
  variant:
  | 'primary'
  | 'primary-outline'
  | 'primary-dark'
  | 'secondary'
  | 'secondary-dark'
  | 'secondary-outline'
  | 'danger'
  | 'links'
  | string;
  icon?: string | ReactNode;
  title: string | ReactNode;
  onClick?: any;
  btnClassName?: string;
  loading?: boolean;
  disabled?: boolean;
  as?: ModalStatusType;
  hasId?: string;
  type?: 'button' | 'submit' | 'reset';
  showButtonInAdminView?: boolean;
  id?: string;
  guideId?: string; // ✅ Added
}

const Button = ({
  variant,
  icon,
  title,
  onClick,
  btnClassName,
  loading,
  type,
  disabled,
  hasId,
  as,
  showButtonInAdminView = false,
  id,
  guideId, // ✅ Added
  ...rest
}: ButtonType): JSX.Element => {
  const userAuthList = useSelector(selectAuthRoutesList);

  const hasReadOnlyImpersonatePermission =
    userAuthList?.auth?.grantedPolicies['wealthlane_is_readonly_session_policy'];

  const computedGuideId =
    guideId ??
    (typeof title === 'string'
      ? `button-${title.toLowerCase().replace(/\\s+/g, '-')}`
      : 'button');

  return (
    // <CheckPermissions type={as} hasId={hasId}>

    <Btn
      className={btnClassName}
      type={type}
      variant={variant}
      onClick={onClick}
      as='button'
      data-guide-id={computedGuideId} // ✅ Injected
      disabled={
        /* (hasReadOnlyImpersonatePermission && showButtonInAdminView === false) || */ disabled ||
        loading
      }
      id={id}
      {...rest}>
      {Boolean(icon) && <span className='material-symbols-outlined'>{icon}</span>}
      {loading === true ? <Spinners borderColor={COLORS.White} size='sm' /> : title}
    </Btn>
    // </CheckPermissions>
  );
};

export default Button;
